// Shared between provisions.tsx (computing the yearly total across merge
// source templates) and add-provision.tsx (recalculating the amount field
// when the merged template's own period changes) - must stay in one place
// so the two never drift apart.
export const OCCURRENCES_PER_YEAR: Record<string, number> = {
    daily: 365,
    weekly: 52,
    fortnightly: 26,
    monthly: 12,
    quarterly: 4,
    'half-yearly': 2,
    yearly: 1,
    // 'custom' intentionally has no entry - there's no fixed period to
    // compute occurrences-per-year from, so callers must special-case it
    // (excluded from merge source selection, and left unrecalculated if
    // chosen as the new template's own period).
};

// A template's `type` value ('half-yearly', 'one-time', etc.) is a clean enum,
// not display text - this turns it into the label a badge/chip actually shows
// (e.g. "Half-Yearly"), capitalizing each hyphen-separated word.
export const formatRecurrenceLabel = (type: string): string =>
    type.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('-');
